import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Collapse } from "react-bootstrap";
import { memo, useState } from "react";
import { useEffect } from "react";

const MenuItems = ({ menus }) => {
  const manualType = useSelector((state) => state.manualTypeChecker.manualType);
  const { category, product, manual } = useSelector(
    (state) => state.sideMenuChecker
  );
  const navigate = useNavigate();

  // useEffect(() => {
  //   setIsOpen({ ...isOpen, [category]: true, [product]: true });
  // }, [manual]);

  const handleManualClick = (item) => {
    if (manual === item.id) return;
    if (item.url) {
      navigate(`/${manualType}${item.url}`);
    }
  };

  const checkSubmenu = (item, depth) => {
    if (item?.submenu?.length > 0) {
      if (depth === 2) return true;
      return item?.submenu?.some((subitem) => subitem?.submenu?.length > 0);
    }
    return false;
  };

  const MenuItem = memo(({ item, index, depth }) => {
    const [isOpen, setIsOpen] = useState({
      [category]: true,
      [product]: true,
      [manual]: true,
    });
    const itemIsOpen = isOpen[item.id] || false;
    const hasSubmenu = checkSubmenu(item, depth);
    if (depth !== 3 && !hasSubmenu) return; // submenu가 없으면 출력하지 않음
    if (depth < 3) {
      return (
        <li key={index} className="snb-item">
          <div
            className={`snb-item-title snb-depth-${depth}`}
            onClick={() => setIsOpen({ ...isOpen, [item.id]: !itemIsOpen })}
          >
            {item.title}
            <span className="arrow-container">
              <span
                className={`arrow ${itemIsOpen ? "rotate-up" : "rotate-right"}`}
              />
            </span>
          </div>
          <Collapse in={itemIsOpen} unmountOnExit>
            <ul>
              {item.submenu.map((subItem, subIndex) => {
                return (
                  <MenuItem
                    key={subIndex}
                    item={subItem}
                    index={subIndex}
                    depth={depth + 1}
                  />
                );
              })}
            </ul>
          </Collapse>
        </li>
      );
    } else if (depth === 3) {
      return (
        <li
          className={`snb-item-title snb-depth-${depth} ${
            item.id === manual && "snb-active"
          }`}
          key={index}
          onClick={() => handleManualClick(item)}
        >
          <span className="snb-item-text">{item.title}</span>
          {item?.platform?.length === 1 && item?.platform[0] === "D1" && (
            <span className="snb-d1">#D</span>
          )}
          {item?.platform?.length === 1 && item?.platform[0] === "G1/G2" && (
            <span className="snb-g1">#G</span>
          )}
          {item?.platform?.length === 1 && item?.platform[0] === "All" && (
            <span className="snb-all">#All</span>
          )}
        </li>
      );
    } else return; // submenu가 없으면 출력하지 않음
  });

  return (
    <ul className="snb">
      {menus?.map((item, index) => {
        return <MenuItem key={index} item={item} index={index} depth={1} />;
      })}
    </ul>
  );
};

export default MenuItems;
